//-- Copyright (c) 2021 TMT Insights Group, LLC
import React from 'react';
import DataTableLayout from '@/components/_common/Layout/DataTableLayout';
import { useAppSelector } from '@/redux/hooks';
import { selectJob } from '@/redux/selectors/jobSelectors';
import { useHistory } from 'react-router-dom';

const JobTabBundleJobs = () => {
  const job = useAppSelector(selectJob);
  const history = useHistory();
  const onRowClick = (e, item) => {
    if (item.id === job.id) return;
    const url = `/jobs/${item.id}`;
    // TODO: we're doing this to simulate ctrl+click,
    // but we should be using the proper element for accessibility
    e.ctrlKey || e.metaKey ? window.open(url) : history.push(url);
  };

  return <DataTableLayout tableKey="jobDetailBundleJobs" simplified onRowClick={onRowClick} />;
};

export default JobTabBundleJobs;
